import { render, staticRenderFns } from "./skuSpec.vue?vue&type=template&id=ed171af4"
import script from "./skuSpec.vue?vue&type=script&lang=js"
export * from "./skuSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports